export interface IGlobalSettingTimes {
  timeReposeDriver: number | null
  holidays: Array<{
    name: string
    times: Array<any>
    from: Date | string | null
    to: Date | string | null
  }>
}

const initData = {}

export default { initData }
